module.exports = __webpack_public_path__ + "de62ebbcf5c60fc9831f7af9ca1736d8.png";